<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-strategy</v-icon>{{$t('profile.strategy.strategies')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileStrategyForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileStrategyForm from '../../components/profilestrategy/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileStrategy';

const { mapFields } = createHelpers({
  getterType: 'profilestrategy/getField',
  mutationType: 'profilestrategy/updateField'
});

export default {
  name: 'ProfileStrategyCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileStrategyForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profilestrategy', ['create', 'reset'])
  }
};
</script>
